import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../components/plei-modal'

import ProductForm from './form'

class ProductEditModal extends React.Component {
  render() {
    const {isOpen, onCancel, editProductId} = this.props
    if (!isOpen) return null
    return (
      <Modal backdrop='static' show={true} onHide={onCancel} className='edit-product-modal'
        title={editProductId ? 'Edit product' : 'Add new product'}
      >
        <ProductForm {...this.props} />
      </Modal>
    )
  }
}

ProductEditModal.propTypes = {
  editProductId: PropTypes.number,
  initialValues: PropTypes.object,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  products: PropTypes.object,
  type: PropTypes.string
}

export default ProductEditModal
